<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الفصل_الثاني-عشر-ج">
<h1><span dir="rtl">#الفصل_الثّاني عشر #ج</span></h1>
<p><img alt=" " src="media/file1.png" style="width:2.84375in;height:0.34403in"/></p>
<p><span dir="rtl">صوتٌ غاضبٌ غيرُ مألوفٍ دوَّى في الفصل الثَّاني عشر فرقة (ج):</span></p>
<p><strong><span dir="rtl">- أعِدْ ما قلتَهُ إن كنتَ تريدني أن أبرحَك ضربًا!</span></strong></p>
<p><span dir="rtl">اتَّضَحَتِ الصورةُ أمام جاكسون حينَ رأى فتًى طويلًا ذا شعرٍ برتقاليّ مجعَّدٍ، يفصلُ بين جبينه وشَعره قطعة قماشٍ زاهية الألوان.</span></p>
<p><span dir="rtl">انتبهَ إلى دومنيك الذي يقف أمامَ ذلك الفتى في خوفٍ عارمٍ وهو يجيبه:</span></p>
<p><strong><span dir="rtl">- أخبرتُك أنا، أخبرتُك أنَّه لا يمكنكَ الجـ.. لوس! لا يُسمَح لــ.. لأحدٍ الجلوس بجوار أمبر!</span></strong></p>
<p><span dir="rtl">قاطعَ جاكسون الحوارَ بينهما في اندفاعٍ:</span></p>
<p><strong><span dir="rtl">- دعْ دومينيك وشأنَه، وتحدَّث معي أنا، مَن أنتَ؟ وماذا تفعلُ هنا؟</span></strong></p>
<p><strong><span dir="rtl">- أُدعَى كريس، طالبٌ جديدٌ، كما أنِّي لَم أعتَد أن يعترضَ أحدٌ على ما أودُّ فعلَه، لذا...</span></strong></p>
<p><span dir="rtl">أشار إلى دومينيك مردفًا:</span></p>
<ul class="line">
<li><strong><span dir="rtl">أزِحْ هذا الفتى مِن أمامي، فهو يُفقِدُني صوابي!</span></strong></li>
</ul>
<p><span dir="rtl">علَت ضحكةُ جاكسون ليجيبَ بعدَها:</span></p>
<p><strong><span dir="rtl">- إذن أنتَ حقًّا تريدُ الجلوسَ بجوار أمبر، حسنًا.. لكَ ذلكَ، ولكن أنصحكَ بطلبِ تابوتٍ جميل أوَّلًا!</span></strong></p>
<p><span dir="rtl">التفتَ دومينيك نحوَ كتلةٍ مِن الشَّعر على أحد المقاعدِ محدِّثًا جاكسون:</span></p>
<p><strong><span dir="rtl">- أخبرتُه أن يأخذَ مكانًا بجوار يزن، هو نائمٌ طوالَ الوقتِ، ولن يزعجَه.</span></strong></p>
<p><strong><span dir="rtl">- إنَّها هنا، أمبر هنا، إلى مقاعدكم هيَّا، أسرعوا!</span></strong></p>
<p><span dir="rtl">صرخَ أحد الطلَّاب ليسرعَ الجميعُ إلى مقاعدهم، إلَّا دومينيك الذي بقيَ متمسِّكًا بذراع جاكسون وكريس الذي أرغمَه الفضولُ في ترقُّبِ تلك التي تُدعَى أمبر.</span></p>
<p><strong><span dir="rtl">- اذهبْ إلى فصلكَ الآنَ دو!</span></strong></p>
<p><span dir="rtl">بالرَّغم مِن أنَّ أمبر همسَت به، إلَّا إنَّ الجميعَ استطاعَ سماعها بوضوحٍ بسببِ الهدوء الذي كان يعمُّ المكان.</span></p>
<p><span dir="rtl">أخذَ كريس ينظر إليها بتمعُّن، على غرارِ بقيّة الفتيات، هي ترتدي البنطال عِوَضًا عن التنانير المتعارَف عليها.</span></p>
<p><span dir="rtl">حاولَ أن يتبيَّن ملامحها أكثر، لا جدوى؛ فقبَّعة الهودي التي ترتديها تحتَ السترة المدرسيَّة، وشَعرها الأشقر القصير الذي يغطِّي أغلبَ ملامحها أخفيَا الكثير.</span></p>
<p><span dir="rtl">كريس بسخرية:</span></p>
<p><span dir="rtl">- <strong>أأنتِ فتاةٌ أم فتًى؟</strong></span></p>
<p><span dir="rtl">أمبر بهدوء:</span></p>
<p><strong><span dir="rtl">- الأعمى يمكنه ملاحظة أنَّني فتاةٌ!</span></strong></p>
<p><span dir="rtl">كريس رفعَ كتفيه بضع بوصات، ثمَّ أخفضها مِن دونِ مبالاةٍ:</span></p>
<p><strong><span dir="rtl">- تبدين كفتًى بهذا الهودي الأزرق الذي ترتدينه.</span></strong></p>
<p><span dir="rtl">أمبر وهي تشير إلى الألوانِ التي تحيط بجبينه:</span></p>
<p><strong><span dir="rtl">- أنتِ تصفين نفسكِ فقط أيَّتُها الفتاة.</span></strong></p>
<p><span dir="rtl">انفجرَ جميع مَن في الفصل ضاحكًا.</span></p>
<p><span dir="rtl">جاكسون مستهزِئًا:</span></p>
<p><span dir="rtl">- <strong>ردَّها إن استطعتَ!</strong></span></p>
<p><span dir="rtl">هسهس كريس:</span></p>
<p><span dir="rtl">- <strong>اصمتْ أنتَ وإلَّا كسرتُ رأسكَ.</strong></span></p>
<p><strong><span dir="rtl">-</span> <span dir="rtl">سأضحك أوَّلًا ثمَّ اكسرْ رأسي.</span></strong></p>
<p><span dir="rtl">أجاب جاكسون ليعودَ للضحك بينما يضرب الأرض بقدمِه، والفصلُ أصبح في فوضى عارمةٍ مجدَّدًا.</span></p>
<p><span dir="rtl">صرخَ الأستاذ الذي دخلَ للتوِّ إلى الفصل، ليجفل الجميعَ، ويعتدلوا في جلستهم:</span></p>
<p><strong><span dir="rtl">- هدووووء.</span></strong></p>
<p><span dir="rtl">هو أردفَ حانقًا:</span></p>
<p><span dir="rtl">- <strong>أنتم طلَّاب المرحلة الأخيرة، راعوا أنَّكم أصبحتُم ناضجين، وتصرَّفُوا على هذا الأساس.</strong></span></p>
<p><span dir="rtl">أشار إلى كريس:</span></p>
<p><strong><span dir="rtl">- أأنتَ الطالب الجديد؟ آه.. دعني أتذكَّر اسمك! كريس.. صحيح!</span></strong></p>
<p><span dir="rtl">أومأ كريس، ليكمل الأستاذ:</span></p>
<p><strong><span dir="rtl">- حسنًا كريس، خذ مكانًا بجوار يزن.</span></strong></p>
<p><span dir="rtl">مطَّ كريس شفتيه وهو يلعن تحتَ أنفاسِه ملتفِتًا إلى حقيبته المدرسيَّة الزَّرقاء بجوار مقعد أمبر:</span></p>
<p><strong><span dir="rtl">- مَن بحقِّ الجحيم أنت؟!</span></strong></p>
<p><span dir="rtl">رفعَت أمبر رأسها لتواجههُ، وتجيبُ في برودٍ أقسمُ إنَّه أوقفَ الدِّماء في عروقه:</span></p>
<p><strong><span dir="rtl">- أمبر.. أمبر ماكويني، تذكَّر هذا الاسم جيِّدًا.</span></strong></p>
<p><span dir="rtl">هو تراجع خطوَتَين إلى الخلف فورَ أن أمعنَ النَّظر في وجهها.</span></p>
<p><span dir="rtl">زوجان مِن الأعين المختلفة</span><a class="footnote-ref" href="#/text/#fn1" id="fnref1">1</a> <span dir="rtl">كانَتا كافيتَين ليطلقَ شهقةً خافتة، وتقودُه قدماه إلى حيثُ مقعده طواعيَّة.</span></p>
<p><span dir="rtl">
</span></p>
</div>
<div class="footnotes">
<hr/>
<ol>
<li id="fn1"><p><span dir="rtl">تغاير لون القزحيَّتَين يسمَّى علميًّا بــ</span> Heterochromia<a class="footnote-back" href="#/text/#fnref1">↩︎</a></p></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?1f64d0ac